import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Table } from "../../components";
import utils from "../../components/toastify/toastify";
import { fish_image } from "../../constant/urls";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
//locall

const PaymentDetails = (props) => {
  const [
    verify_payment_support_fish_error,
    verify_payment_support_fish_loading,
    verify_payment_support_fish_data,
    verify_payment_support_fish_function,
  ] = useRequest({
    method: "post",
    url: "/verify_payment_support_fish",
    isFunction: true,
  });

  const [
    verify_payment_term_fish_error,
    verify_payment_term_fish_loading,
    verify_payment_term_fish_data,
    verify_payment_term_fish_function,
  ] = useRequest({
    method: "post",
    url: "/verify_payment_term_fish",
    isFunction: true,
  });

  const [
    verify_cart_fish_error,
    verify_cart_fish_loading,
    verify_cart_fish_data,
    verify_cart_fish_function,
  ] = useRequest({
    method: "post",
    url: "/verify_cart_fish",
    isFunction: true,
  });

  let history = useHistory();
  const [
    get_payment_details_error,
    get_payment_details_loading,
    get_payment_details_data,
    get_payment_details_function,
  ] = useRequest({
    method: "post",
    url: "/get_payment_details",
    body: {
      payment_id: props.match.params.id,
    },
  });

  const data = get_payment_details_data?.data;
  const couponCodes = [...new Set((data?.carts_info || []).map((item) => item.discount_code).filter(Boolean))];
  const paymentType = data?._type === "free" ? "رایگان با کد تخفیف" : data?._type === "online" ? "آنلاین" : "کارت به کارت";
  const paymentStatus = data?._status === "paid" ? "پرداخت شده" : data?._status === "waiting" ? "در انتظار تایید" : "پرداخت نشده";

  return !data ? null : (
    <>
      <div class="content-header row"></div>
      <div class="content-body">
        <section className="card card-body">
          <div class="row" style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ marginBottom: "10px" }}></div>
            <div style={{ marginBottom: "10px" }}>
              شماره سفارش: {data._id}
            </div>
            <div style={{ marginBottom: "10px" }}>
              خریدار: {data.user_id?.name || "—"} {data.user_id?.phone_number ? `(${data.user_id.phone_number})` : ""}
            </div>
            <div style={{ marginBottom: "10px" }}>
              مبلغ سفارش: {Number(data._price || 0).toLocaleString("fa-IR")} تومان
            </div>
            <div style={{ marginBottom: "10px" }}>
              روش پرداخت: {paymentType} — وضعیت: {paymentStatus}
            </div>
            <div style={{ marginBottom: "10px" }}>
              کد رهگیری : {data._tracking_code || data._terminal_id || "—"}
            </div>
            <div style={{ marginBottom: "10px" }}>
              توضیحات پرداخت :{" "}
              {data._des === "initial_payment" ? "پرداخت اولیه" : null}
              {data._des === "term_support_payment"
                ? "پرداخت پشتیبانی ترم"
                : null}
              {data._des === "term_payment" ? "پرداخت ترم" : null}
            </div>
            {couponCodes.length > 0 && (
              <div style={{ marginBottom: "10px" }}>
                کد تخفیف: {couponCodes.join("، ")}
              </div>
            )}
            <div className="card border" style={{ marginBottom: "16px", padding: "14px" }}>
              <strong>محصولات سفارش</strong>
              <ul style={{ margin: "10px 0 0", paddingRight: "20px" }}>
                {(data.products || []).map((item, index) => (
                  <li key={`${item.product_id?._id || item.product_id || index}-${index}`}>
                    {item.product_id?.title || "محصول"}
                    {Number(item.quantity || 1) > 1 ? ` — تعداد: ${item.quantity}` : ""}
                  </li>
                ))}
              </ul>
            </div>
            {(data.shipping_address || data.postal_code) && (
              <div className="card border" style={{ marginBottom: "16px", padding: "14px" }}>
                <strong>اطلاعات ارسال سفارش</strong>
                <div style={{ marginTop: "10px" }}>نشانی: {data.shipping_address || "—"}</div>
                <div style={{ marginTop: "6px" }}>کد پستی: {data.postal_code || "—"}</div>
              </div>
            )}

            <div style={{ marginBottom: "10px" }}>تصویر فیش واریزی :</div>
            {data.fish_img ? (
              <>
                {" "}
                <img
                  src={fish_image + data.fish_img.name}
                  alt="fish"
                  style={{
                    width: "100%",
                    maxWidth: "30rem",
                    objectFit: "cover",
                    marginBottom: "10px",
                  }}
                />
                <div style={{ marginBottom: "10px" }}>
                  وضعیت تراکنش :
                  {data._status === "paid"
                    ? "پرداخت شده"
                    : data._status === "unpaid"
                    ? "پرداخت نشده"
                    : data._status === "waiting"
                    ? "در انتظار تایید"
                    : null}
                  {data._status === "paid" ? (
                    <button
                      type="button"
                      class="btn btn-warning round mr-1 mb-1 btn-sm"
                      style={{ width: "fit-content" }}
                      onClick={() => {
                        {
                          data._des === "initial_payment"
                            ? verify_cart_fish_function({
                                payment_id: props.match.params.id,
                                _status: false,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت رد شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                        {
                          data._des === "term_support_payment"
                            ? verify_payment_support_fish_function({
                                payment_id: props.match.params.id,
                                _status: false,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت رد شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                        {
                          data._des === "term_payment"
                            ? verify_payment_term_fish_function({
                                payment_id: props.match.params.id,
                                _status: false,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت رد شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                      }}
                    >
                      رد فیش
                    </button>
                  ) : null}
                  {data._status === "unpaid" ? (
                    <button
                      type="button"
                      class="btn btn-success round mr-1 mb-1 btn-sm"
                      style={{ width: "fit-content" }}
                      onClick={() => {
                        {
                          data._des === "initial_payment"
                            ? verify_cart_fish_function({
                                payment_id: props.match.params.id,
                                _status: true,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت تایید شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                        {
                          data._des === "term_support_payment"
                            ? verify_payment_support_fish_function({
                                payment_id: props.match.params.id,
                                _status: true,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت تایید شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                        {
                          data._des === "term_payment"
                            ? verify_payment_term_fish_function({
                                payment_id: props.match.params.id,
                                _status: true,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت تایید شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                      }}
                    >
                      تایید فیش
                    </button>
                  ) : null}
                  {data._status === "waiting" ? (
                    <>
                      <button
                        type="button"
                        class="btn btn-success round mr-1 mb-1 btn-sm"
                        style={{ width: "fit-content" }}
                        onClick={() => {
                          {
                            data._des === "initial_payment"
                              ? verify_cart_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: true,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت تایید شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                          {
                            data._des === "term_support_payment"
                              ? verify_payment_support_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: true,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت تایید شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                          {
                            data._des === "term_payment"
                              ? verify_payment_term_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: true,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت تایید شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                        }}
                      >
                        تایید فیش
                      </button>
                      <button
                        type="button"
                        class="btn btn-warning round mr-1 mb-1 btn-sm"
                        style={{ width: "fit-content" }}
                        onClick={() => {
                          {
                            data._des === "initial_payment"
                              ? verify_cart_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: false,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت رد شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                          {
                            data._des === "term_support_payment"
                              ? verify_payment_support_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: false,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت رد شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                          {
                            data._des === "term_payment"
                              ? verify_payment_term_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: false,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت رد شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                        }}
                      >
                        رد فیش
                      </button>
                    </>
                  ) : null}
                </div>
              </>
            ) : null}
          </div>
        </section>
      </div>
      {/* <!-- BEGIN: Content--> */}
    </>
  );
};

export { PaymentDetails };
